import { Outlet } from "react-router-dom";
import { AgentSidebar } from "../agent/agent-sidebar";
import { Breadcrumbs } from "./breadcrumbs";
import { Footer } from "./footer";
import { TopBar } from "./top-bar";

export function AppLayout(): React.ReactElement {
  return (
    <div className="h-screen bg-background flex flex-col overflow-hidden">
      <TopBar />
      <div className="flex flex-1 min-h-0 pt-[49px]">
        {/* Main content — scrolls independently from sidebar */}
        <div className="flex-1 overflow-y-auto min-w-0">
          <div className="mx-auto max-w-[1920px] px-4 py-6">
            <Breadcrumbs />
            <main>
              <Outlet />
            </main>
          </div>
          <Footer />
        </div>

        {/* Agent sidebar — inline, not overlaid */}
        <AgentSidebar />
      </div>
    </div>
  );
}
